import React, { FunctionComponent, SVGProps } from 'react'

export const IconRu: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="16" height="11" rx="2" fill="#1A47B8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.33398H16V11.0007H0V7.33398Z"
      fill="#F93939"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H16V3.66667H0V0Z"
      fill="white"
    />
  </svg>
)
